<div class="container mx-auto pb-20">
  @if (item$ | async; as item) {
  <div class="padding2 space-y-8">
    <div class="text-center">
      <div
        class="flex w-full items-center justify-center bg-inherit h-[160px] md:h-[200px]"
      >
        <img
          [src]="item?.photoUrl"
          alt="Company Logo"
          width="144"
          height="144"
          class="h-24 w-24 rounded-full lg:h-36 lg:w-36 aspect-auto border border-gray-200"
        />
      </div>
      <div class="space-y-1">
        <h1 class="text-2xl font-bold text-center">
          {{ item?.name }}
        </h1>
        <p class="text-lg">
          {{ item?.compantagline }}
        </p>
        <div
          class="text-sm flex items-center space-x-2 justify-center text-gray-600 whitespace-nowrap"
        >
          <span>{{ item?.companysize }}</span>
          <span>&bull;</span>
          <span>Founded {{ item?.companyfounded }}</span>
        </div>
        <div class="flex items-center justify-center space-x-4 text-sm">
          <a
            [href]="item?.companywebsite"
            class="text-blue-700 flex items-center space-x-1"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span>Website</span>
            <img src="website_link.svg" alt="" class="w-4" />
          </a>
          <a
            [href]="item?.companylinkedin"
            class="flex items-center space-x-1 text-blue-700"
            rel="noopener noreferrer"
            target="_blank"
          >
            <span>LinkedIn</span>
            <img src="website_link.svg" alt="" class="w-4" />
          </a>
        </div>
      </div>
    </div>
    <div class="space-y-5 py-16">
      <h2 class="text-xl font-medium">Openings</h2>

      <ng-container *ngIf="jobs$ | async as jobs">
        <div
          *ngFor="let job of jobs; let i = index"
          class="border-b border-gray-200 pb-5"
        >
          <div class="flex items-center justify-between">
            <div>
              <h3 class="font-semibold">
                <a
                  [href]="
                    'https://app.voyagex.ai/#/registration/' +
                    id$ +
                    '?jobid=' +
                    job.id
                  "
                  class="hover:underline hover:underline-offset-2"
                >
                  {{ job?.title }}
                </a>
              </h3>
              <p class="text-sm text-gray-600">
                {{
                  readMore[i]
                    ? job?.description
                    : formatString(job?.description)
                }}
                <span
                  *ngIf="job?.description?.length > 150"
                  (click)="handleReadMore(i)"
                  class="cursor-pointer text-gray-800 hover:underline"
                >
                  {{ readMore[i] ? "read less" : "read more" }}
                </span>
              </p>
            </div>
            <a
              [href]="
                'https://app.voyagex.ai/#/registration/' +
                id$ +
                '?jobid=' +
                job.id
              "
              class="text-center px-3 py-1 text-sm font-medium bg-blue-600 text-white rounded-full hover:bg-blue-800 transition-all"
            >
              Apply
            </a>
          </div>
        </div>
      </ng-container>

      <div class="flex items-center justify-between pb-5">
        <div>
          <h3 class="font-semibold">
            <a
              [href]="
                'https://app.voyagex.ai/#/registration/' + id$ + '?jobid=others'
              "
              class="hover:underline hover:underline-offset-2"
            >
              Hiring Seafarers!
            </a>
          </h3>
          <p class="text-sm text-gray-600">
            Join us for exciting opportunities at sea
          </p>
        </div>
        <a
          [attr.href]="
            'https://app.voyagex.ai/#/registration/' + id$ + '?jobid=others'
          "
          class="text-center rounded-full px-3 py-1 text-sm font-medium bg-blue-600 text-white hover:bg-blue-800 hover:text-white active:bg-blue-500 transition-all"
        >
          Register
        </a>
      </div>
    </div>

    <div class="space-y-5">
      <h2 class="text-xl font-medium">Overview</h2>

      <p *ngIf="item?.companyoverview" class="text-gray-700">
        {{ item?.companyoverview }}
      </p>
      <div class="space-y-2">
        <div
          *ngIf="
            item?.headaddress || item?.city || item?.state || item?.country
          "
        >
          <label class="text-sm font-semibold">Address</label>
          <p>
            {{ item?.headaddress && item?.headaddress + ", " }}
            {{ item?.city && item?.city + ", " }}
            {{ item?.state && item?.state + ", " }}
            {{ item?.country && (item?.country | titlecase) }}
            {{ item?.zip && " " + item?.zip }}
          </p>
        </div>
        <div *ngIf="item?.companyfounded">
          <label class="text-sm font-semibold">Founded</label>
          <p class="text-gray-700">{{ item?.companyfounded }}</p>
        </div>
        <div *ngIf="item?.country">
          <label class="text-sm font-semibold">Country</label>
          <p class="text-gray-700 capitalize">
            {{ item?.country | titlecase }}
          </p>
        </div>
        <div *ngIf="item?.companysize">
          <label class="text-sm font-semibold">Company Size</label>
          <p class="text-gray-700">{{ item?.companysize }}</p>
        </div>
      </div>
    </div>
  </div>

  }
</div>
